import styled from "@emotion/styled";
import get from "lodash/get";
import { useTranslation } from "react-i18next";
import type { JSX } from "react";
import { AppTheme } from "packages/dsaui/src/theme";

interface ContainerProps {
  fontSize: number;
  transform: string;
  theme?: AppTheme;
}

const Container = styled.span<ContainerProps>(
  ({ fontSize, transform, theme }) => `
  font-size: ${get(theme, "fontSizes." + fontSize)};
  display: inline-flex;
  align-self: center;

  svg {
    font-size: ${get(theme, "fontSizes." + fontSize)};
    fill: currentcolor;
    transform: ${transform};
  }
`,
);

export interface IconProps {
  title: string;
  d: string;
  color?: string;
  fontSize?: number;
  transform?: string;
  width?: number;
  height?: number;
}

export const Icon = ({
  title,
  d,
  color = "currentcolor",
  fontSize = 1,
  transform = "none",
  width = 32,
  height = 32,
  ...rest
}: IconProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Container fontSize={fontSize} transform={transform} {...rest}>
      <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox={`0 0 ${width} ${height}`}
      >
        <title>{t(title)}</title>
        <path fill={color} d={d} />
      </svg>
    </Container>
  );
};

export default Icon;
